import {LocalDateTime} from '@js-joda/core';
import {get} from 'lodash-es';

import {events} from '../events';

// A GET response is stale if a newer GET was dispatched after it (latest-wins).
// requestSeq is stamped on the GET action; the SUCCESS/ERROR action carries the
// originating action at meta.previousAction (redux-axios-middleware). Guards the
// on-load auto-submit vs a fast manual search resolving out of order.
const isStale = (state, action) => {
    const seq = get(action, 'meta.previousAction.requestSeq');
    return seq != null && state.latestRequestSeq != null && seq !== state.latestRequestSeq;
};

export const mmAppointmentsReducer = {
    [events.MM_APPOINTMENTS_GET]: (state = {}, action) => ({
        ...state,
        isLoading: true,
        latestRequestSeq: action.requestSeq
    }),
    [events.MM_APPOINTMENTS_SUCCESS]: (state, action) => {
        // Drop a stale response — keep the in-flight latest request's state intact.
        if (isStale(state, action)) {
            return state;
        }
        const {payload: {data}} = action;
        const appointments = get(data, 'data.appointments', []);
        const totalCount = get(data, 'data.totalCount', 0);
        const offset = get(data, 'data.offset', 0);

        const more = (offset + appointments.length) < totalCount;

        return {
            isLoading: false,
            error: false,
            more,
            rowData: appointments,
            totalCount,
            timestamp: LocalDateTime.now(),
            latestRequestSeq: state.latestRequestSeq
        };
    },
    [events.MM_APPOINTMENTS_ERROR]: (state, action) => {
        if (isStale(state, action)) {
            return state;
        }
        return {
            ...state,
            isLoading: false,
            error: action.error
        };
    },

    [events.MM_APPOINTMENTS_CREATE]: (state) => ({
        ...state,
        isCreating: true,
        createError: null,
        createSuccessMessage: null
    }),
    [events.MM_APPOINTMENTS_CREATE_SUCCESS]: (state, {payload: {data}}) => ({
        ...state,
        isCreating: false,
        createError: null,
        createSuccessMessage: get(data, 'data', 'MM appointment(s) saved successfully')
    }),
    [events.MM_APPOINTMENTS_CREATE_ERROR]: (state, action) => ({
        ...state,
        isCreating: false,
        createError: action.error,
        createSuccessMessage: null
    }),

    [events.MM_APPOINTMENTS_DELETE]: (state) => ({
        ...state,
        isDeleting: true,
        deleteError: null,
        deleteSuccessMessage: null
    }),
    [events.MM_APPOINTMENTS_DELETE_SUCCESS]: (state, {payload: {data}}) => ({
        ...state,
        isDeleting: false,
        deleteError: null,
        deleteSuccessMessage: get(data, 'data', 'MM appointment(s) deleted successfully')
    }),
    [events.MM_APPOINTMENTS_DELETE_ERROR]: (state, action) => ({
        ...state,
        isDeleting: false,
        deleteError: action.error,
        deleteSuccessMessage: null
    })
};
